import Joi from 'joi';

export const bankingFormSchema =  Joi.object({
  bank_name: Joi.string()
    .min(3)
    .max(255)
    .required()
    .messages({
      "string.empty": "Bank name is required.",
      "string.min": "Bank name must be at least 3 characters.",
      "string.max": "Bank name must not exceed 255 characters.",
    }),

    branch_name: Joi.string()
    .min(3)
    .max(255)
    .required()
    .messages({
      "string.empty": "Branch name is required.",
      "string.min": "Branch name must be at least 3 characters.",
      "string.max": "Branch name must not exceed 255 characters.",
    }),

    account_no: Joi.string()
    .min(9)
    .max(18)
    .pattern(/^\d+$/)
    .required()
    .messages({
      // "string.empty": "Account number is required.",
      // "string.length": "Account number must be 11 digits long.",
      // "string.pattern.base": "Account number must be numeric.",
      "string.empty": "Account number is required.",
      "string.min": "Account number must be at least 9 digits.",
      "string.max": "Account number must not exceed 18 digits.",
      "string.pattern.base": "Account number must be numeric.",
    }),

    ifsc_no: Joi.string()
    .pattern(/^[A-Z]{4}0[A-Z0-9]{6}$/)
    .required()
    .messages({
      "string.empty": "IFSC number is required.",
      "string.pattern.base": "IFSC number must be in the correct format (e.g., SBIN0XXXXXX).",
    }),

    account_type: Joi.string()
    .valid("current", "savings")
    .required()
    .messages({
      "string.empty": "Account type is required.",
      "any.only": "Account type must be either 'current' or 'savings'.",
    }),

    is_primary: Joi.boolean()
    .required()
    .messages({
      "boolean.base": "Primary account status must be true or false.",
      "any.required": "Primary account status is required.",
    }),
    is_force_primary:Joi.boolean()
    .required()
    .messages({
      "boolean.base": "Force Primary status must be true or false.",
      "any.required": "Force Primary account status is required.",
    }),
}).unknown(true);
